/* eslint-disable max-len */
import { CompanySizeTierEnum, LevelOfExperienceEnum } from '../consts/enums';
import KEYS from './keys';

const STRINGS = {
  [KEYS.PREVIEW]: 'Preview',
  [KEYS.REMOTE]: 'Remote',
  [KEYS.US_UK_COUNTRY_REMOTE]: 'Anywhere in the {{countryCode}}',
  [KEYS.SPECIFIC_COUNTRY_REMOTE]: 'Anywhere in {{countryCode}}',
  [KEYS.LOGIN_TITLE]: 'Hello Partner',
  [KEYS.LOGIN_DESCRIPTION]: 'To sign in please enter your login info',
  [KEYS.LOGIN_BUTTON]: 'Log In',
  [KEYS.LOGIN_EMAIL_LABEL]: 'Email Address',
  [KEYS.LOGIN_PASSWORD_LABEL]: 'Password',
  [KEYS.LOGIN_EMAIL_VALIDATION]: 'Must be a valid email',
  [KEYS.LOGIN_EMAIL_REQUIRED_VALIDATION]: 'Email is required',
  [KEYS.LOGIN_PASSWORD_REQUIRED_VALIDATION]: 'Password is required',
  [KEYS.LAYOUT_HOME_TITLE]: 'Home',
  [KEYS.LAYOUT_OPS_POSITIONS_TITLE]: 'Ops - Positions',
  [KEYS.LAYOUT_OPS_ACCOUNTS_TITLE]: 'Ops - Accounts',
  [KEYS.LAYOUT_POSITION_TITLE]: 'Positions',
  [KEYS.LAYOUT_SALES_TITLE]: 'Sales',
  [KEYS.LAYOUT_TALENTS_TITLE]: 'Talents',
  [KEYS.LAYOUT_ACCOUNTS_TITLE]: 'Accounts',
  [KEYS.LAYOUT_AI_TITLE]: 'AI',
  [KEYS.LOGIN_ERROR]: 'Incorrect username or password',
  [KEYS.OPS_POSITIONS_PAGE_TITLE]: 'Ops - Positions',
  [KEYS.OPS_POSITIONS_PAGE_DOWNLOAD_CSV_TITLE]: 'Download CSV',
  [KEYS.POSITIONS_PAGE_TITLE]: 'Positions',
  [KEYS.POSITIONS_DETAILS_PAGE_TITLE_NAV]: 'Position Details',
  [KEYS.MATCH_DETAILS]: 'Match Details',
  [KEYS.POSITIONS_PAGE_CREATE_BUTTON]: 'Create New Position',
  [KEYS.POSITIONS_LIST_FILTER_ACCOUNT]: 'Account',
  [KEYS.POSITIONS_LIST_FILTER_STATUS]: 'Status',
  [KEYS.POSITIONS_LIST_FILTER_PRICING_PLAN]: 'Plan',
  [KEYS.POSITIONS_LIST_FILTER_STATE]: 'State',
  [KEYS.TALENT_LIST_FILTER_CURRENT_COMPANY]: 'Current Company',
  [KEYS.TALENT_LIST_FILTER_CURRENT_POSITION]: 'Current Position',
  [KEYS.POSITIONS_LIST_TABLE_HEADER_TITLE]: 'Position title / ID',
  [KEYS.POSITIONS_LIST_TABLE_HEADER_ACCOUNT]: 'Account',
  [KEYS.POSITIONS_LIST_TABLE_HEADER_LOCATION]: 'Location',
  [KEYS.POSITIONS_LIST_TABLE_HEADER_MATCHES]: 'Matches',
  [KEYS.POSITIONS_LIST_TABLE_HEADER_STATUS]: 'Status',
  [KEYS.POSITIONS_LIST_TABLE_HEADER_UPDATED]: 'Last Update',
  [KEYS.POSITIONS_LIST_TABLE_HEADER_CREATED]: 'Date Created',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_TITLE]: 'Position title / ID',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_ACCOUNT]: 'Account',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_LAST_PUBLISHED]: 'Last Published',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_ACCEPTANCE]: 'Acceptance',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_PUBLISHED]: 'Published',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_TO_REVIEW]: 'To Review',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_APPROVED]: 'Approved',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_DECLINED]: 'Declined',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_CONTACTED]: 'Contacted',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_REPLIED]: 'Replied',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_UPDATED]: 'Last Update',
  [KEYS.ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_CREATED]: 'Date Created',
  [KEYS.FILTER_EMPTY]: 'No filters applied',
  [KEYS.FILTER_LABEL_STATUS]: 'Status',
  [KEYS.FILTER_LABEL_STATE]: 'State',
  [KEYS.FILTER_LABEL_TITLE]: 'Search',
  [KEYS.FILTER_LABEL_ACCOUNT]: 'Account',
  [KEYS.SEARCH_INPUT_PLACEHOLDER]: 'Enter a keyword',
  [KEYS.TABLE_ROW_NO_RESULT]: 'No Results',
  [KEYS.TALENTS_ERROR]: 'Something went wrong',
  [KEYS.DELETE]: 'Delete',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_FIRSTNAME]: 'First Name',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_LASTNAME]: 'Last Name',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_EMAIL]: 'Email',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_PHONE]: 'Phone',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_CITY]: 'City',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_STATE]: 'State',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_COUNTRY]: 'Country',
  [KEYS.ID]: 'ID: {{id}}',
  [KEYS.LAST_CHANGED_BY]: 'Last changed {{date}} by {{username}}',
  [KEYS.CREATED_BY_AT]: 'Created by {{username}} at {{date}}',
  [KEYS.UPDATED_BY_AT]: 'Updated by {{username}} at {{date}}',
  [KEYS.UNKNOWN]: 'Unknown',
  [KEYS.VERSION]: 'Version {{version}}',
  [KEYS.SAVE_CHANGES]: 'Save Changes',
  [KEYS.NEW_TALENT]: 'New Talent',
  [KEYS.NEW_MATCH]: 'New Match',
  [KEYS.TALENTS_PAGE_CREATE_BUTTON]: 'Create New Talent',
  [KEYS.TALENTS_PAGE_TITLE]: 'Talents',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.EMAIL_INVALID]:
    'Email is Invalid!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.EMAIL_REQIRED]:
    'Email is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.FIRSTNAME]:
    'First Name is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.LASTNAME]:
    'Last Name is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.PHONE]: 'Phone is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.STATE]: 'State is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.COUNTRY]:
    'Country is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.CITY]: 'City is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_TITLE]: 'Basic Details',
  [KEYS.SAVE_CHANGES]: 'Save Changes',
  [KEYS.POSITION_TABLE_ROW_RESULT_COUNT]: 'Positions',
  [KEYS.MATCH_TABLE_ROW_RESULT_COUNT]: 'Matches',
  [KEYS.POSITION_DETAILS_SUB_TITLE_CREATE]: 'Created by {{name}}',
  [KEYS.TALENTS_ERROR]: 'Something went wrong',
  [KEYS.EDIT]: 'Edit',
  [KEYS.VIEW]: 'View',
  [KEYS.UNPUBLISH]: 'Back to draft (Unpublish)',
  [KEYS.TALENTS_ACTION_MENU_HISTORY]: 'Talent History',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_FIRSTNAME]: 'First Name',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_LASTNAME]: 'Last Name',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_EMAIL]: 'Email',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_PHONE]: 'Phone',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_CITY]: 'City',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_STATE]: 'State',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_COUNTRY]: 'Country',
  [KEYS.LAST_CHANGED_BY]: 'Last changed {{date}} by {{username}}',
  [KEYS.VERSION]: 'Version {{version}}',
  [KEYS.SAVE_CHANGES]: 'Save Changes',
  [KEYS.NEW_TALENT]: 'New Talent',
  [KEYS.TALENTS_PAGE_CREATE_BUTTON]: 'Create New Talent',
  [KEYS.CREATE_NEW_ACCOUNT]: 'Create New Account',
  [KEYS.TALENTS_PAGE_TITLE]: 'Talents',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.EMAIL_INVALID]:
    'Email is Invalid!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.EMAIL_REQIRED]:
    'Email is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.FIRSTNAME]:
    'First Name is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.LASTNAME]:
    'Last Name is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.PHONE]: 'Phone is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.STATE]: 'State is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.COUNTRY]:
    'Country is required!',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_VALIDATION.CITY]: 'City is required!',
  [KEYS.TALENT_EDITOR_BREADCRUMBS_TITLE]: 'Talent Details',
  [KEYS.TALENTS_EDIT_BASIC_DETAILS_TITLE]: 'Basic Details',
  [KEYS.SAVE_CHANGES]: 'Save Changes',
  [KEYS.POSITION_DETAILS_SUB_TITLE_CREATE]: 'Created by {{name}}',
  [KEYS.POSITION_DETAILS_SUB_TITLE_UPDATE]: 'Last change by {{name}}',
  [KEYS.POSITIONS_DETAILS_CREATE_MATCH_BUTTON]: 'Add New Match',
  [KEYS.POSITIONS_DETAILS_FILTER_MATCH_STATUS]: 'Match Status',
  [KEYS.POSITIONS_DETAILS_FILTER_ENGAGE_STATUS]: 'Engagement Status',
  [KEYS.POSITIONS_DETAILS_TABLE_HEADER_TITLE]: 'Match Name + ID',
  [KEYS.POSITIONS_DETAILS_TABLE_HEADER_POSITION]: 'Current Position',
  [KEYS.POSITIONS_DETAILS_TABLE_HEADER_MATCH]: 'Match Status',
  [KEYS.POSITIONS_DETAILS_TABLE_HEADER_ENGAGEMENT]: 'Engagement Status',
  [KEYS.POSITIONS_DETAILS_TABLE_HEADER_DATE]: 'Date Created',
  [KEYS.POSITIONS_DETAILS_TABLE_VIEW_ACTIVITY_ACTION]: 'View History Log',
  [KEYS.POSITIONS_DETAILS_TABLE_VIEW_MATCH_ACTION]: 'View Match',
  [KEYS.POSITIONS_DETAILS_TABLE_EDIT_MATCH_ACTION]: 'Edit Match',
  [KEYS.POSITIONS_DETAILS_TABLE_EDIT_TALENT_ACTION]: 'Edit Talent',
  [KEYS.POSITIONS_DETAILS_TABLE_PREVIEW_ACTION]: 'Preview',
  [KEYS.POSITIONS_DETAILS_TABLE_DELETE_ACTION]: 'Delete',
  [KEYS.NOVICE]: 'Novice',
  [KEYS.EXPERT]: 'Expert',
  [KEYS.SKILLS]: 'Skills',
  [KEYS.MULTI_SELECT.RESULTS]: '{{count}} results',
  [KEYS.MULTI_SELECT.NO_RESULTS]: 'No results',
  [KEYS.MULTI_SELECT.SEARCH_PLACEHOLDER]: 'Type to search',
  [KEYS.TITLE_EXPERIENCE]: 'Experience',
  [KEYS.TITLE_EDUCATION]: 'Education',
  [KEYS.START_DATE_TITLE]: 'Start Date',
  [KEYS.END_DATE_TITLE]: 'End Date',
  [KEYS.CURRENT]: 'Current',
  [KEYS.LABEL_YEAR]: 'Year',
  [KEYS.LABEL_MONTH]: 'Month',
  [KEYS.TITLE_ROLE]: 'Role',
  [KEYS.COMPANY]: 'Company',
  [KEYS.EMPTY_AVATAR]: 'Empty_avatar',
  [KEYS.TITLE_LABEL]: 'Label',
  [KEYS.TITLE_LOGO]: 'Logo',
  [KEYS.EDUCATION_INSTITUTE]: 'Education institute',
  [KEYS.ADD_NEW_CHAPTER_EXPERIENCE]: 'Add Another Career Chapter',
  [KEYS.ADD_NEW_CHAPTER_EDUCATION]: 'Add Another Education',
  [KEYS.ADD_NEW_SOCIAL_LINK]: 'Add Another Link',
  [KEYS.OUT_OF]: 'out of',
  [KEYS.LINKEDIN_PROFILE_MESSAGE]:
    'Please send the talent`s Linkedin profile URL',
  [KEYS.CONTINUE]: 'Continue',
  [KEYS.CANCEL]: 'Cancel',
  [KEYS.LINKEDIN_DIALOG_ERROR]: `We couldn't find this talent - it's
  either private or doesn't exist.`,
  [KEYS.LINKEDIN_URL]: 'LinkedIn URL',
  [KEYS.TALENT_LINKEDIN_URL]: 'Talent LinkedIn URL',
  [KEYS.SKILLS_PLACEHOLDER]: 'Type skill name',
  [KEYS.OUT_OF]: '{{counter}} out of {{total}}',
  [KEYS.TITLE_NAVIGATION]: '{{title}} Chapter',
  [KEYS.ADD_ANOTHER]: 'Add Another',
  [KEYS.KEY_ATTRIBUTES]: 'Key Attributes',
  [KEYS.POSITIONS_CREATE_NEW.NAVIGATION_CURRENT]: 'New Position',
  [KEYS.POSITIONS_CREATE_NEW.AVATAR_TITLE]: 'New',
  [KEYS.POSITIONS_CREATE_NEW.BTN_DRAFT]: 'Save Draft',
  [KEYS.POSITIONS_CREATE_NEW.BTN_DRAFT_SAVED]: 'Draft Saved',
  [KEYS.POSITIONS_CREATE_NEW.BTN_PUBLISH]: 'Publish',
  [KEYS.POSITIONS_CREATE_NEW.BTN_PUBLISHED]: 'Publish',
  [KEYS.POSITIONS_CREATE_NEW.BTN_RE_PUBLISHED]: 'Re-Publish',
  [KEYS.POSITIONS_CREATE_EDIT.NAVIGATION_CURRENT]: 'Position ',
  [KEYS.TALENTS_PAGE_EDIT_BREADCRUMBS_TITLE]: 'Talents Edit',
  [KEYS.BASIC_DETAILS]: 'Basic Details',
  [KEYS.SOCIAL_LINKS]: 'Social Links',
  [KEYS.EXPERIENCE]: 'Experience',
  [KEYS.EDUCATION]: 'Education',
  [KEYS.KEY_ATTRIBUTES]: 'Key Attributes',
  [KEYS.SKILLS]: 'Skills',
  [KEYS.COMPANY_BACKGROUND]: 'Company Background',
  [KEYS.LOCATION_REGIONS]: 'Regions',
  [KEYS.EXACT_LOCATIONS]: 'Exact Locations',
  [KEYS.CHOOSE_ICON]: 'Choose an icon',
  [KEYS.INSIGHT_LABEL]: 'Insight Label',
  [KEYS.INSIGHT_KEY]: 'Experience Label',
  [KEYS.POSITION_BASIC_INFO.TITLE]: 'Basic Information',
  [KEYS.POSITION_BASIC_INFO.SUBTITLE]: 'Mandatory',
  [KEYS.POSITION_BASIC_INFO.ACCOUNT_LABEL]: 'Associated Account',
  [KEYS.POSITION_BASIC_INFO.ACCOUNT_PLACEHOLDER]: 'Select Account',
  [KEYS.POSITION_BASIC_INFO.COMPANY_LABEL]: 'Company',
  [KEYS.POSITION_BASIC_INFO.POSITION_TITLE]: 'Position Title',
  [KEYS.POSITION_BASIC_INFO.INTERNAL_OWNER_LABEL]: 'Internal Owner',
  [KEYS.POSITION_BASIC_INFO.INTERNAL_OWNER_PLACEHOLDER]: 'Select Internal Owner',
  [KEYS.POSITION_BASIC_INFO.POSITION_LOCATION]: 'Position Location',
  [KEYS.POSITION_BASIC_INFO.POSITION_REMOTE]: 'Remote Position',
  [KEYS.POSITION_BASIC_INFO.COMPANY_DEFAULT_NAME]: 'Company name',
  [KEYS.POSITION_BASIC_INFO.INTERNAL_USERS_TEXT_VALIDATION]: 'Please fill out this field',
  [KEYS.POSITION_BASIC_INFO.LEVEL_OF_EXPERIENCE]: 'Level of experience',
  [KEYS.POSITION_LOCATION.X_MORE_LOCATIONS]: 'and <0>{{locationsAmount}} more</0>',
  [KEYS.POSITION_LOCATIONS_SECTION.TITLE]: 'Locations',
  [KEYS.POSITION_LOCATIONS_SECTION.MILES_RADIUS_LABEL]: 'Miles Radius',
  [KEYS.POSITION_TIMEZONE.TITLE]: 'Timezone settings',
  [KEYS.POSITION_TIMEZONE.TIMEZONE_LABEL]: 'Position timezone',
  [KEYS.POSITION_COMPANY_SIZES.TITLE]: 'Position Company Sizes',
  [KEYS.POSITION_COMPANY_SIZES.LABEL]: 'Company Sizes',
  [KEYS.REGION_LABEL]: 'Region',
  [KEYS.EXACT_LOCATION_LABEL]: 'Exact Location',
  [KEYS.POSITION_JOB_DESCRIPTION.TITLE]: 'Job Description',
  [KEYS.POSITION_JOB_DESCRIPTION.SAVED_FILE]: 'Saved file',
  [KEYS.POSITION_JOB_DESCRIPTION.SOURCE]: 'Source',
  [KEYS.POSITION_JOB_DESCRIPTION.SNAPSHOT]: 'Snapshot',
  [KEYS.POSITION_JOB_DESCRIPTION.LINK_PLACEHOLDER]: 'Enter URL',
  [KEYS.ACCOUNTS_PAGE_CREATE_BUTTON]: 'Create New Account',
  [KEYS.ACCOUNTS_ACTION_MENU_EDIT]: 'Edit',
  [KEYS.ACCOUNTS_ACTION_MENU_DELETE]: 'Delete',
  [KEYS.ACCOUNTS_ACTION_MENU_VIEW_POSITIONS]: 'View Positions',
  [KEYS.ACCOUNTS_ACTION_MENU_LOGIN_AS_ADMIN]: 'Login as Admin',
  [KEYS.ACCOUNTS_TOTAL_COUNT]: '{{ count }} Accounts',
  [KEYS.ACCOUNTS_TABLE_HEADER_NAME_AND_ID]: 'Account Name / ID',
  [KEYS.ACCOUNTS_NAME]: 'Account Name',
  [KEYS.ACCOUNTS_SUBDOMAIN]: 'Subdomain',
  [KEYS.COMPANY_SIZE]: 'Company Size',
  [KEYS.ACCOUNTS_TABLE_HEADER_ASSOCIATED_COMPANY]: 'ASSOCIATED COMPANY',
  [KEYS.ACCOUNTS_TABLE_HEADER_SUBDOMAIN]: 'SUBDOMAIN',
  [KEYS.ACCOUNTS_TABLE_HEADER_STATUS]: 'STATUS',
  [KEYS.ACCOUNTS_TABLE_HEADER_POSITIONS]: 'POSITIONS',
  [KEYS.ACCOUNTS_TABLE_HEADER_EMAIL_SENDERS]: 'EMAIL SENDERS',
  [KEYS.ACCOUNTS_TABLE_HEADER_ATS]: 'ATS',
  [KEYS.DISCONNECT_ATS]: 'Disconnect ATS',
  [KEYS.DISCONNECT_ATS_CONFIRMATION_TITLE]: 'Disconnect ATS',
  [KEYS.DISCONNECT_ATS_CONFIRMATION_MESSAGE]: 'Are you sure you want to disconnect {atsName} from this account? Linked positions will no longer sync with the ATS.',
  [KEYS.DISCONNECT_ATS_SUCCESS]: 'ATS disconnected successfully',
  [KEYS.ATS_INTEGRATION]: 'ATS Integration',
  [KEYS.ATS_LINKED_AT]: 'Linked at',
  [KEYS.ACCOUNTS_TABLE_HEADER_LAST_UPDATE]: 'LAST UPDATE',
  [KEYS.ACCOUNTS_TABLE_HEADER_DATE_CREATED]: 'DATE CREATED',
  [KEYS.ACCOUNTS_TABLE_HEADER_PLAN]: 'PLAN',
  [KEYS.TALENTS_TABLE_HEADER_NAME_AND_ID]: 'Talent Name / Id',
  [KEYS.TALENTS_TABLE_HEADER_JOB_TITLE]: 'Job Title',
  [KEYS.TALENTS_TABLE_HEADER_CURRENT_COMPANY]: 'Current Company',
  [KEYS.POSITION_VALIDATION_ERROR.JOB_TITLE]: 'Please enter position title',
  [KEYS.POSITION_VALIDATION_ERROR.LOCATION]:
    'Please enter position location or choose “remote” in location is not relevant',
  [KEYS.POSITION_VALIDATION_ERROR.ACCOUNT]: 'Please select associated account',
  [KEYS.ADD_NEW_MATCH]: 'Add New Match',
  [KEYS.CREATE_NEW_TALENT]: 'Create New Talent',
  [KEYS.SEARCH_TALENT_PLACEHOLDER]: 'Search talent by ID or LinkedIn URL',
  [KEYS.NO_RESULTS]: 'NO RESULTS',
  [KEYS.RESULTS_FOUND]: '{{results}} RESULTS FOUND',
  [KEYS.POSITION_NAME]: 'Position {{ name }}',
  [KEYS.STATUS_DRAFT]: 'Draft',
  [KEYS.STATUS_PUBLISHED]: 'Published',
  [KEYS.POSITION_VALIDATION_ERROR.URL]: 'Url field must be a valid URL',
  [KEYS.POSITION_SKILLS.REQUIRED_LABEL]: 'Required',
  [KEYS.POSITION_COMPANY_BACKGROUND.REQUIRED_LABEL]: 'Required',
  [KEYS.POSITION_ATTRIBUTES.TITLE]: 'Attributes',
  [KEYS.POSITION_ATTRIBUTES.SUBTITLE]: '{{ count }} out of 10',
  [KEYS.POSITION_ATTRIBUTES.PLACEHOLDER]: 'Type to add another',
  [KEYS.CONTACT_INFORMATION]: 'Contact Information',
  [KEYS.DIALOG.BTN_GO_BACK]: 'Go Back',
  [KEYS.POSITION_DELETE_DIALOG.TITLE]: 'Delete This Position?',
  [KEYS.POSITION_DELETE_DIALOG.ACTION_BTN]: 'Delete This Position',
  [KEYS.POSITION_DELETE_DIALOG.SUB_TITLE]:
    'All information associated with this position will be deleted. This action cannot be undone.',
  [KEYS.ACCOUNT_DELETE_DIALOG.TITLE]: 'Delete This Account?',
  [KEYS.ACCOUNT_DELETE_DIALOG.ACTION_BTN]: 'Delete This Account',
  [KEYS.ACCOUNT_DELETE_DIALOG.SUB_TITLE]:
      'All information associated with this account will be deleted. This action cannot be undone.',
  [KEYS.POSITION_PUBLISH_DIALOG.TITLE]: 'Is it perfect?',
  [KEYS.POSITION_PUBLISH_DIALOG.ACTION_BTN]: 'Seems perfect. Publish!',
  [KEYS.POSITION_PUBLISH_DIALOG.SUB_TITLE]:
    'Once you hit publish, this position will be displayed to the users. ' +
    'Please make sure it’s perfect :)',
  [KEYS.POSITION_DETAILS_ACTION.DELETE]: 'Delete',
  [KEYS.POSITION_DETAILS_ACTION.BACK_TO_DRAFT]: 'Back to draft (Unpublish)',
  [KEYS.POSITION_DETAILS_ACTION.CLOSE_POSITION]: 'Close position',
  [KEYS.POSITION_DETAILS_ACTION.OPEN_POSITION]: 'Open position',
  [KEYS.POSITION_ERRORS.DELETE]:
    'Ouch! there was a problem delete position (error: {{ internalErrorCode }}) Please try again',
  [KEYS.POSITION_ERRORS.SAVE]:
    'Ouch! there was a problem saving your changes (error: {{ internalErrorCode }}) ' +
    'Please try again',
  [KEYS.ACCOUNT_ERRORS.DELETE]:
    'There was a problem deleting the account (error: {{ internalErrorCode }}) Please try again',
  [KEYS.MATCH_PROMOTE_ERROR_MESSAGE]:
    'There was a problem promoting the match, Please try again',
  [KEYS.DESCRIPTION_PLACEHOLDER]: 'Description',
  [KEYS.SUBTITLE_PLACEHOLDER]: 'Subtitle',
  [KEYS.PUBLISH]: 'Publish',
  [KEYS.REPUBLISH]: 'Re-Publish',
  [KEYS.ACCOUNT_STATUSES.ACTIVE]: 'Active',
  [KEYS.ACCOUNT_STATUSES.INACTIVE]: 'Inactive',
  [KEYS.ACCOUNT_STATUSES.ONBOARDING]: 'Onboarding',
  [KEYS.ACCOUNT_STATUSES.SUSPENDED]: 'Suspended',
  [KEYS.POSITION_STATUSES.DELETED]: 'Deleted',
  [KEYS.POSITION_STATUSES.DRAFT]: 'Draft',
  [KEYS.POSITION_STATUSES.PUBLISHED]: 'Published',
  [KEYS.POSITION_STATES.OPEN]: 'Open',
  [KEYS.POSITION_STATES.CLOSED]: 'Closed',
  [KEYS.MATCH_STATUSES.DELETED]: 'Deleted',
  [KEYS.MATCH_STATUSES.DRAFT]: 'Draft',
  [KEYS.MATCH_STATUSES.PUBLISHED]: 'Published',
  [KEYS.MATCH_STATUSES.ARCHIVED]: 'Archived',
  [KEYS.ENGAGEMENT_STATUS.PENDING_REVIEW]: 'To Review',
  [KEYS.ENGAGEMENT_STATUS.ENGAGED]: 'Engaged',
  [KEYS.ENGAGEMENT_STATUS.DECLINED]: 'Declined',
  [KEYS.UPDATE_CONTACT_INFO]: 'Update Contact Info',
  [KEYS.UPDATE_MESSAGE]: 'Contact info was updated  successfully',
  [KEYS.NOTIFICATION_MESSAGE]: 'Users who requested this information will be notified',
  [KEYS.EDIT_TALENT_INFO]: 'Edit Talent Information',
  [KEYS.TALENT_INFO]: 'Talent Information',
  [KEYS.INSIGHTS]: 'Insights',
  [KEYS.TYPE_PLACEHOLDER]: 'Type',
  [KEYS.ORDER_PLACEHOLDER]: 'Order',
  [KEYS.DESCRIPTION_OPTIONAL_PLACEHOLDER]: 'Description (optional)',
  [KEYS.KPI_VALUE]: 'KPI {{ value }}',
  [KEYS.FIT_OVERVIEW]: 'Fit Overview',
  [KEYS.INSIGHT_IMAGES]: 'Full + Images',
  [KEYS.INSIGHT_FULL]: 'Full + Icons',
  [KEYS.INSIGHT_ELEMENT]: 'Graphic Element',
  [KEYS.INSIGHT_HEADLINE_ONLY]: 'Headline + Icon',
  [KEYS.INSIGHT_SPIDER]: '',
  [KEYS.HEADLINE_PLACEHOLDER]: 'Headline',
  [KEYS.APPLY_CHANGES]: 'Apply Changes',
  [KEYS.NEW_UPDATE_AVAILABLE]: 'New Update Available',
  [KEYS.MATCH_DELETE_DIALOG.TITLE]: 'Delete This Match?',
  [KEYS.MATCHES_DELETE_DIALOG_TITLE]: 'Delete These Matches?',
  [KEYS.MATCHES_DELETE_DIALOG_SUB_TITLE]: 'This action cannot be undone.',
  [KEYS.MATCHES_DELETE_DIALOG_ACTION_BTN]: 'Delete These Matches',
  [KEYS.MATCH_DELETE_DIALOG.ACTION_BTN]: 'Delete This Match',
  [KEYS.MATCH_DELETE_DIALOG.SUB_TITLE]:
    'All changes made to this match will be deleted. This action cannot be undone.',
  [KEYS.MATCH_PUBLISH_DIALOG.TITLE]: 'Is it perfect?',
  [KEYS.MATCH_PUBLISH_DIALOG.ACTION_BTN]: 'Seems perfect. Publish!',
  [KEYS.MATCH_PUBLISH_DIALOG.SUB_TITLE]: 'Once you hit publish, this match will be displayed to ' +
    'the position users. Please make sure it’s perfect :)',
  [KEYS.ACCOUNT_IS_COMPANY_MANUAL]: 'MANUAL',
  [KEYS.COUNTER_ACTIVITIES]: '{{counter}} Activities',
  [KEYS.ENTITY_NAME]: '{{entity}} History',
  [KEYS.HISTORY_ERROR_MESSAGE_TITLE]: 'Sorry, nothing to see here.',
  [KEYS.HISTORY_ERROR_MESSAGE_TEXT]: 'Hopefully we\'ll have some activity soon!',
  [KEYS.HISTORY_NO_RESULTS_TITLE]: 'There\'s Nothing To Show',
  [KEYS.HISTORY_NO_RESULTS_TEXT]:
  ' Looks like there are no activities that match your filter,' +
  'Try to adjust your search filter.',
  [KEYS.HISTORY_EARTH_TITLE]: 'The beginning of the Earth',
  [KEYS.HISTORY_EARTH_TEXT]: '4.54 billion years ago',
  [KEYS.CLEAR]: 'Clear',
  [KEYS.HISTORY_ENTITY_NAME]: '{{entity}} History',
  [KEYS.DONE]: 'Done',
  [KEYS.ACCOUNT_DELETE_CONFIRMATION]: 'Enter account name to confirm',
  [KEYS.MATCH_PAGE_TAB_ENGAGEMENT]: 'Engagement',
  [KEYS.MATCH_PAGE_TAB_TALENT]: 'Talent Info',
  [KEYS.MATCH_PAGE_TAB_METADATA]: 'Metadata',
  [KEYS.TALENT_VIEW_UPDATED_VERSION]: 'View Updated Version',
  [KEYS.ACTIVITY_TYPE]: 'Activity Type',
  [KEYS.MADE_BY]: 'Made By',
  // TO DO WHEN ERRORS ARE READY FROM SERVER
  [KEYS.MATCH_ENGAGEMENT_STATUS_RESPONSE.INTERESTED]: 'Interested',
  [KEYS.MATCH_ENGAGEMENT_STATUS_RESPONSE.NO_RESPONSE]: 'No Response',
  [KEYS.MATCH_ENGAGEMENT_STATUS_RESPONSE.NOT_INTERESTED]: 'Not Interested',
  [KEYS.MATCH_ENGAGEMENT_EMPTY_STATE.TITLE]: 'There are no recent engagements to show.',
  [KEYS.MATCH_ENGAGEMENT_EMPTY_STATE.BODY]:
  'Once you add new engagements, they will appear in this list.',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.TITLE]: 'Add an Engagement with {{talentName}}',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.SAVE]: 'Save Engagement',
  [KEYS.TITLE_EDIT_TEXT]: 'Edited this {{value}}',
  [KEYS.CREDIT_ALLOCATIONS.TITLE]: 'Match Credits History',
  [KEYS.CREDIT_ALLOCATIONS.NO_ALLOCATIONS]: 'No credits have been purchased yet for this account.',
  [KEYS.MATCH_ENGAGEMENT_STATUS_NOT_INTERESTED.NOT_LOOKING_FOR_NEW_OPPORTUNITIES]:
  'Not looking for a new opportunity',
  [KEYS.MATCH_ENGAGEMENT_STATUS_NOT_INTERESTED.OPEN_TO_OTHER_OPPORTUNITIES]:
  'Not interested but open to other opportunities',
  [KEYS.MATCH_ENGAGEMENT_STATUS_NOT_INTERESTED.OTHER]: 'Other',
  [KEYS.MATCH_ENGAGEMENT_STATUS_INTERESTED_REASON]: 'Interested hearing more',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.DATE_OF_ENGAGEMENT]: 'Date of engagement',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.THROUGH_CHANNEL]: 'Through Channel',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.UPDATE_ENGAGEMENT]: 'Update Engagement Status',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.REASON_SELECTION]: 'Select a reason',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.NOTE]: 'Note (optional)',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.MATCH_STATUS]: 'Match Status',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.LEAVE_IT_AS_IS]: 'Leave it as is',
  [KEYS.MATCH_ENGAGEMENT_CHANNEL.PHONE]: 'Phone',
  [KEYS.MATCH_ENGAGEMENT_CHANNEL.LINKEDIN]: 'LinkedIn',
  [KEYS.MATCH_ENGAGEMENT_CHANNEL.EMAIL]: 'Email',
  [KEYS.MATCH_ENGAGEMENT_CHANNEL.OTHER]: 'Other',
  [KEYS.MATCH_ENGAGEMENT_CHANNEL.SMS]: 'SMS',
  [KEYS.CREATED]: 'Created',
  [KEYS.THIS_ENTITY]: 'This {{entity}}',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.SAVE_ERROR]:
  'Ouch! there was a problem saving your changes (error: {{ internalErrorCode }}) ' +
  'Please try again',
  [KEYS.GENERIC_SAVE_CHANGES_ERROR]: 'Ouch! there was a problem saving your changes',
  [KEYS.VIEW_MATCHES]: 'View Matches',
  [KEYS.VIEW_ACCOUNT]: 'View Account',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.TEXT_VALIDATION]: 'Please fill out this field',
  [KEYS.MATCH_NEW_ENGAGEMENT_RECORDS_MODAL.RESPONSE_VALIDATION]:
   'Please select a response',
  [KEYS.STATISTICS.MATCH_TITLE]: 'Matches By Status',
  [KEYS.STATISTICS.ALL_MATCHES]: 'ALL Matches',
  [KEYS.LOADING]: 'Loading...',
  [KEYS.LOAD_MATCH_PREVIEW_ACTION]: 'load match preview',
  [KEYS.CREATE_NEW_MATCH_ACTION]: 'create new match',
  [KEYS.UPDATE_MATCH_ACTION]: 'update match',
  [KEYS.REJECT_MATCH_ACTION]: 'reject match',
  [KEYS.UPLOAD_IMAGE_ACTION]: 'upload image',
  [KEYS.FAILED_TO_ACTION]: 'Failed to {{ actionName }}',
  [KEYS.MATCH_PREVIEW]: 'Match Preview',
  [KEYS.FATAL_PAGE_ERROR]:
    'Uh oh, it looks like we are having trouble loading this page.' +
    'Please try refreshing the page,' +
    "if it doesn't work please contact Maor Barazani because he probably messed something up.",
  [KEYS.CANNOT_LOAD_PREVIEW_URL]: 'Cannot load preview URL',
  [KEYS.ACCOUNTS_ASSOCIATED_COMPANY]: 'Associated Company',
  [KEYS.ACCOUNTS_ASSOCIATED_COMPANY_LOCATION]: 'Associated Company Location',
  [KEYS.MANUAL_BTN_TEXT]: 'Add Manually',
  [KEYS.QUESTION_FIND_COMPANY]: "Can't find your company?",
  [KEYS.CREATE_ACCOUNT_BTN]: 'Create Account',
  [KEYS.CREATE_TALENT_MANUALLY]: 'Create Talent Manually',
  [KEYS.LINKEDIN_VALIDATION]: 'Please Enter a valid Linkedin URL',
  [KEYS.HOME_PAGE.TITLE]: 'Good {{ partOfDay }} {{ name }}!',
  [KEYS.PARTS_OF_DAY.NIGHT]: 'Night',
  [KEYS.PARTS_OF_DAY.EVENING]: 'Evening',
  [KEYS.PARTS_OF_DAY.AFTERNOON]: 'Afternoon',
  [KEYS.PARTS_OF_DAY.MORNING]: 'Morning',
  [KEYS.HOME_PAGE.TASKS.TITLE]: 'Your Inbox',
  [KEYS.HOME_PAGE.TASKS.FILTER_ALL]: 'All Issues',
  [KEYS.HOME_PAGE.TASKS.FILTER_OPEN]: 'Open Issues',
  [KEYS.HOME_PAGE.SIDE_STATISTICS.TITLE]: 'What’s Happening',
  [KEYS.HOME_PAGE.STATISTICS.TITLE]: 'Statistics',
  [KEYS.HOME_PAGE.EMPTY_TITLE]: 'All Done!',
  [KEYS.HOME_PAGE.EMPTY_DESCRIPTION]:
    'More tasks for you will be shown here as they are added, so check back often',
  [KEYS.ACCOUNT_LOGIN_SECTION_TEXT]: 'Account Information',
  [KEYS.ACCOUNT_PANEL_TITLE]: 'Account Information',
  [KEYS.ACCOUNTS_EDIT_ERROR_MESSAGE_UPLOAD_IMAGE]: 'Failed to upload image',
  [KEYS.MANUAL]: 'Manual',
  [KEYS.COMPANY_SIZE_SMALL]: 'Small',
  [KEYS.COMPANY_SIZE_MEDIUM]: 'Medium',
  [KEYS.COMPANY_SIZE_LARGE]: 'Large',
  [KEYS.CHANGE]: 'Change',
  [KEYS.HOME_PAGE.TASKS.MATCH_FLOW_FAILED]: '<1>{{ positionName }}</1> <0>from</0> <1>{{ accountName }}</1> <0>match flow failed</0> <1>{{ count }}</1> <0> times </0>',
  [KEYS.HOME_PAGE.TASKS.REQUEST_MATCHES]: '<1>{{ userName }}</1> <0>from</0> {{ accountName }} requested more matches for <1>{{ positionName }}</1>',
  [KEYS.HOME_PAGE.TASKS.CONTACT_INFO]:
    '<1>{{ accountName }}</1> <0>asked for</0> <1>{{ talentName }}</1> <2>contact info</2> <0> in </0> <1>{{ positionName }}</1>',
  [KEYS.HOME_PAGE.TASKS.CONTACT_INFO_AGGREGATED]:
    '<1>{{ accountName }}</1> <0>asked for</0>  <1>{{ count }}</1> <0>talents</0> <2>contact info</2> <0> in </0> <1>{{ positionName }}</1>',
  [KEYS.HOME_PAGE.TASKS.ENGAGE]:
    '<1>{{ accountName }}</1> <0>asked to</0> <2>engage</2> <0>with</0> <1>{{ talentName }}</1> <0> in </0> <1>{{ positionName }}</1>',
  [KEYS.HOME_PAGE.TASKS.ENGAGE_AGGREGATED]:
    '<1>{{ accountName }}</1> <0>asked to</0> <2>engage</2> <0>with</0> <1>{{ count }}</1> <0>talents in</0> <1>{{ positionName }}</1>',
  [KEYS.HOME_PAGE.TASKS.UPDATED_STATUS]:
    '<1>{{ accountName }}</1> <0>updated the status of</0> <1>{{ count }}</1> <0>matches of </0> <1>{{ positionName }}</1>',
  [KEYS.HOME_PAGE.TASKS.ONBOARDING_COMPLETED]:
    '<0>New account</0> <1>{{ accountName }}</1> <0>onboarded, position:</0> <1>{{ positionName }}</1>, <0>user email:</0> <1>{{ userEmail }}</1>, <0>match engine triggered:</0> <1>{{ wasMatchFlowTriggered }}</1>.',
  [KEYS.ACCOUNT_LOGIN_BTN_TEXT]: 'Account Information',
  [KEYS.ERROR_MESSAGE_CREATE_ACCOUNT]: 'Create account failed',
  [KEYS.CHANGE]: 'Change',
  [KEYS.DELETE_ACCOUNT]: 'Delete Account',
  [KEYS.ACCOUNT_REQUIRED]: 'Please enter account name',
  [KEYS.ACCOUNT_COMPANY_NAME_REQUIRED]: 'Please enter associated company name',
  [KEYS.ACCOUNT_COMPANY_SIZE_REQUIRED]: 'Please select an option for company size',
  [KEYS.ACCOUNT_SUBDOMAIN_INVALID]: 'Please enter subdomain',
  [KEYS.ACCOUNT_NOTIFICATION_MANUAL_MESSAGE]: 'Associated company manually added',
  [KEYS.REJECTED_REASONS.OVERQUALIFIED]: 'Overqualified',
  [KEYS.REJECTED_REASONS.INSUFFICIENT_EXPERIENCE]: 'Insufficient Experience',
  [KEYS.REJECTED_REASONS.LOCATION]: 'Location',
  [KEYS.REJECTED_REASONS.RELEVANT_SKILLS]: 'Missing Skills',
  [KEYS.REJECTED_REASONS.RELEVANT_EDUCATION]: 'Education',
  [KEYS.REJECTED_REASONS.OTHER]: 'Something Else',
  [KEYS.REJECTED_REASONS.BROKEN_LINK]: 'Broken Link',
  [KEYS.REJECTED_REASONS.RECENT_ROLE_CHANGE]: 'Recent Role Change',
  [KEYS.REJECTED_REASONS.IRRELEVANT_TITLE]: 'Irrelevant Title',
  [KEYS.REJECTED_REASONS.IRRELEVANT_COMPANIES]: 'Irrelevant Companies',
  [KEYS.REJECTED_REASONS.UNSPECIFIED]: 'Unspecified',
  [KEYS.TALENT]: 'Talent',
  [KEYS.EMPTY]: 'Empty',
  [KEYS.ADDED]: 'Added',
  [KEYS.REMOVED]: 'Removed',
  [KEYS.STATUS_CHANGED]: 'Status Changed',
  [KEYS.MATCH]: 'Match',
  [KEYS.POSITION]: 'Position',
  [KEYS.QUOTES.TITLE]: 'Quote of the Day',
  [KEYS.COMPANY_NOT_FOUND_LINKEDIN]: 'We couldn`t find a company called {{companyName}} in our database',
  [KEYS.ADD_COMPANY_TO_DB]: 'Add "{{companyName}}" to our database?',
  [KEYS.ACADEMIC_NOT_FOUND_LINKEDIN]: 'We couldn`t find an institution in this link',
  [KEYS.ACADEMIC_NOT_FOUND_DB]: 'We couldn`t find an institution "{{academicName}}" in our database',
  [KEYS.ADD_MANUALLY]: 'Add Manually',
  [KEYS.NO_OPTIONS_ACADEMIC_PLACEHOLDER]: 'Please enter institution name or institution LinkedIn url',
  [KEYS.NO_OPTIONS_PLACEHOLDER]: 'Please enter company LinkedIn url',
  [KEYS.SEARCHING]: 'Searching...',
  [KEYS.CREATE_NEW_COMPANY]: 'Create New Company',
  [KEYS.COMPANY_LOGO]: 'Company Logo',
  [KEYS.COMPANY_NAME_VALIDATION]: 'Company name is required',
  [KEYS.EDUCATION_NAME_VALIDATION]: 'Institution name is required',
  [KEYS.CONFIRM]: 'Confirm',
  [KEYS.ERROR_MESSAGE_GET_ACCOUNT]: 'Get account failed',
  [KEYS.ERROR_LOGIN_AS_ADMIN]: 'Login as Admin action failed',
  [KEYS.FIELD_OF_STUDY]: 'Field of Study',
  [KEYS.DEGREE]: 'Degree',
  [KEYS.EDIT]: 'Edit',
  [KEYS.DEFAULT_ERROR_MESSAGE]: 'Something went wrong, Server error',
  [KEYS.PLACEHOLDER_ENTER_EMAIL]: 'Enter an email',
  [KEYS.PLACEHOLDER_ENTER_PHONE]: 'Enter a phone number',
  [KEYS.ADD_PHONE_NUMBER]: 'Add Phone Number',
  [KEYS.ADD_EMAIL]: 'Add Email',
  [KEYS.GENERAL_SERVER_ERROR]: 'Failed to load data from server',
  [KEYS.RUN_SEARCH]: 'Run Search',
  [KEYS.RUN_STATUS]: 'Run Status',
  [KEYS.ENGINE_RUNS]: 'Engine Runs',
  [KEYS.COMPLETED]: 'COMPLETED',
  [KEYS.ERROR]: 'ERROR',
  [KEYS.DEGRADED]: 'DEGRADED',
  [KEYS.CREATED_CANDIDATES]: 'Created candidates',
  [KEYS.DUPLICATE_CANDIDATES]: 'Duplicate candidates',
  [KEYS.LAST_RUN]: 'Last run ID {{ id }} at {{date}}',
  [KEYS.PROGRESS_RUNNING_MESSAGE]: 'Running... {{count}}% completed',
  [KEYS.NEW_RUN]: 'New run',
  [KEYS.TALENTS]: 'Talents',
  [KEYS.ENGINE_RESULTS]: 'Engine Results',
  [KEYS.ENGINE_RESULTS_TABLE_RUN_ACTIONS.PUBLISH]: 'Promote & Publish',
  [KEYS.ENGINE_RESULTS_TABLE_RUN_ACTIONS.DRAFT]: 'Promote To App',
  [KEYS.ENGINE_RESULTS_TABLE_RUN_ACTIONS.DELETE]: 'Delete',
  [KEYS.MATCH_ENGINE]: 'Match Engine',
  [KEYS.CONVERSATION]: 'Conversation',
  [KEYS.APP_MATCHES]: 'App Matches',
  [KEYS.SIMILARITY_SCORE]: 'Similarity',
  [KEYS.RANK]: 'Rank',
  [KEYS.MATCH_NAME_AND_ID]: 'Match Name + ID',
  [KEYS.CURRENT_POSITION]: 'Current Position',
  [KEYS.SENIORITY_TARGET_RANGE]: 'Seniority range',
  [KEYS.WTL_SCORE]: 'Wtl',
  [KEYS.LAYOFF_SCORE]: 'Layoff',
  [KEYS.TALENT_NETWORK_SCORE]: 'Connection score',
  [KEYS.TALENT_SEMANTIC_SCORE]: 'Talent semantic score',
  [KEYS.TALENT_SEMANTIC_ABOVE_MIN_COUNT]: 'Talent semantic min count',
  [KEYS.RUN_ID]: 'Run ID',
  [KEYS.DATE_ADDED]: 'Date added',
  [KEYS.ENGINE_SEARCH_LOGS]: 'Engine Search Logs',
  [KEYS.CLOSE]: 'Close',
  [KEYS.PROGRESS_STATUSES.COMPLETED]: 'Completed',
  [KEYS.PROGRESS_STATUSES.IN_PROGRESS]: 'Running',
  [KEYS.PROGRESS_STATUSES.ERROR]: 'Failed',
  [KEYS.NO_RESULTS_FOR_THIS_RUN]: 'No new results for this run',
  [KEYS.PROGRESS_STATUSES.CANCELED]: 'Canceled',
  [KEYS.PROGRESS_STATUSES.PENDING]: 'Pending',
  [KEYS.INPUT_PARAMETERS]: 'Input Parameters',
  [KEYS.ENGINE_PARAMETERS]: 'Engine Parameters',
  [KEYS.NO_LOGS_NO_WORRIES]: 'No logs, no worries',
  [KEYS.NO_MUTCH_HAPPENING_HERE]: 'Not much happening here yet, but stay tuned!',
  [KEYS.RUN]: 'Run',
  [KEYS.EQUALIZER_WEIGHT]: 'Equalizer weights',
  [KEYS.WEIGHT_NAME]: 'Weight name',
  [KEYS.MAX_EXPERIENCE]: 'Max Months of experience',
  [KEYS.MIN_EXPERIENCE]: 'Min Months of experience',
  [KEYS.CURRENT_JOB_TITLE]: 'Current job title',
  [KEYS.LOCATION]: 'Location',
  [KEYS.CURRENT_COMPANY_NAME]: 'Current company name',
  [KEYS.CURRENT_COMPANY_SIZE_MIN]: 'Current company size min',
  [KEYS.CURRENT_COMPANY_SIZE_MAX]: 'Current company size max',
  [KEYS.COMPANY_LINKEDIN]: 'Company Linkedin',
  [KEYS.SEARCH_PARAMETERS]: 'Search parameters',
  [KEYS.LOCATION_COUNTRY]: 'Location (country)',
  [KEYS.MATCH_SELECTED]: 'Match Selected',
  [KEYS.MATCHES_SELECTED]: 'Matches Selected',
  [KEYS.MATCH_FLOW_ID]: 'Match flow id',
  [KEYS.MATCH_FLOWS]: 'Match flows',
  [KEYS.MATCH_F_VERSION]: 'Match F. Version',
  [KEYS.RUN_DATE]: 'Run Date',
  [KEYS.STATUS]: 'Status',
  [KEYS.ID_TITLE]: 'ID',
  [KEYS.RUN_ID_TITLE]: 'Run ID',
  [KEYS.RUN_TIME]: 'Run Time',
  [KEYS.MATCH_SELECTED]: 'Match Selected',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TITLE]: 'Match Constraints',
  [KEYS.POSITION_MATCH_CONSTRAINTS.MINIMUM_MONTHS_OF_EXPERIENCE]: 'Months of experience (Min)',
  [KEYS.POSITION_MATCH_CONSTRAINTS.MAXIMUM_MONTHS_OF_EXPERIENCE]: 'Months of experience (Max)',
  [KEYS.POSITION_MATCH_CONSTRAINTS.MAXIMUM_MONTHS_OF_EXPERIENCE_TARGET_ROLES]:
    'Months of experience target roles (Max)',
  [KEYS.POSITION_MATCH_CONSTRAINTS.MINIMUM_MONTHS_OF_EXPERIENCE_TARGET_ROLES]:
    'Months of experience target roles (Min)',
  [KEYS.POSITION_MATCH_CONSTRAINTS.MINIMUM_MONTHS_OF_CURRENT_JOB]: 'Minimum months of current job',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_COMPANIES]: 'Target Companies',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_LOCATION_STATE]: 'Target locations (by states)',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_CITIES]: 'Target cities',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_CITIES_RADIUS]: 'Target cities radius',
  [KEYS.POSITION_MATCH_CONSTRAINTS.HARDCODED_EXEMPLARS]: 'Hardcode exemplars',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_EDUCATION_SCHOOLS]: 'Target education institutes',
  [KEYS.POSITION_MATCH_CONSTRAINTS.COMPANY_SEMANTIC_SEARCH]: 'Company semantic search',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TALENT_SEMANTIC_SEARCH]: 'Talent semantic search',
  [KEYS.POSITION_MATCH_CONSTRAINTS.COMPANY_SIZES]: 'Company sizes',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TALENT_SEMANTIC_SEARCH_REQUIREMENTS]: 'Requirements',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_JOB_TITLES]: 'Target job titles',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_EDUCATION_FIELD_OF_STUDIES]: 'Target education field of studies',
  [KEYS.POSITION_MATCH_CONSTRAINTS.TARGET_EDUCATION_DEGREE]: 'Target education degree',
  [KEYS.POSITION_MATCH_CONSTRAINTS.PLACEHOLDER]: 'Enter {{ title }}',
  [KEYS.CLOSED_BY]: 'Closed by {{username}} at {{date}}',
  [KEYS.CLOSED]: 'Closed',
  [KEYS.REOPEN]: 'Reopen',
  [KEYS.REOPEN_POSITION_DIALOG_TITLE]: 'Reopen Position',
  [KEYS.REOPEN_POSITION_DIALOG_SUBTITLE]: 'Are you sure you want to reopen this position? This will change the position status to "Open".',
  [KEYS.REOPEN_POSITION_DIALOG_CONFIRM]: 'Reopen Position',
  [KEYS.CLOSE_POSITION_DIALOG_TITLE]: 'Close Position',
  [KEYS.CLOSE_POSITION_DIALOG_SUBTITLE]: 'Please select a reason for closing this position',
  [KEYS.POSITION_CANCELED]: 'This position was canceled',
  [KEYS.POSITION_ALREADY_FULFILLED]: 'This position was already fulfilled',
  [KEYS.OTPION_CLOSE_REASON_OTHER]: 'Other reason',
  [KEYS.SELECT_A_REASON]: 'Select a reason',
  [KEYS.PLEASE_TYPE_YOUR_YOUR_OTHER_REASON]: 'Please type your other reason',
  [KEYS.PROMOTING]: 'Promoting',
  [KEYS.REJECTED_REASON_TITLE]: 'Rejected',
  [KEYS.FAILED_TO]: 'Failed to',
  [KEYS.TRIAL]: 'Trial',
  [KEYS.LITE]: 'Lite',
  [KEYS.TRIAL_ENDED]: 'Trial Ended',
  [KEYS.PAID]: 'Paid',
  [KEYS.CANCELLED]: 'Cancelled',
  [KEYS.PAID_PLAN]: 'Paid Plan',
  [KEYS.OPEN_POSITION_TITLE]: 'Open Positions',
  [KEYS.USER_SEATS_TITLE]: 'User Seats & Credits',
  [KEYS.BILLING_CYCLE]: 'Billing Cycle',
  [KEYS.BILLING_MENU.ONE_YEAR]: '1 Year',
  [KEYS.BILLING_MENU.QUARTERLY]: 'Quarterly',
  [KEYS.BILLING_MENU.MONTHLY]: 'Monthly',
  [KEYS.LEVEL_OF_EXPERIENCE[LevelOfExperienceEnum.StartingOut]]: 'Starting Out',
  [KEYS.LEVEL_OF_EXPERIENCE[LevelOfExperienceEnum.EntryLevel]]: 'Entry Level',
  [KEYS.LEVEL_OF_EXPERIENCE[LevelOfExperienceEnum.SomewhatExperienced]]: 'Somewhat Experienced',
  [KEYS.LEVEL_OF_EXPERIENCE[LevelOfExperienceEnum.HighlyExperienced]]: 'Highly Experienced',
  [KEYS.LEVEL_OF_EXPERIENCE[LevelOfExperienceEnum.IncrediblyExperienced]]: 'Incredibly Experienced',
  [KEYS.COMPANY_SIZES[CompanySizeTierEnum.Small]]: 'Small',
  [KEYS.COMPANY_SIZES[CompanySizeTierEnum.Medium]]: 'Medium',
  [KEYS.COMPANY_SIZES[CompanySizeTierEnum.Large]]: 'Large',
  [KEYS.COMPANY_SIZES[CompanySizeTierEnum.VeryLarge]]: 'Very Large',
  [KEYS.PRICING_PLAN]: 'Pricing Plan',
  [KEYS.PAYMENT_LINKS]: 'Payment links',
  [KEYS.PAYMENT_LINK_T2_CUSTOM]: 'T2 Custom',
  [KEYS.PAYMENT_LINK_T3_CUSTOM]: 'T3 Custom',
  [KEYS.PAYMENT_LINK_T4_CUSTOM]: 'T4 Custom',
  [KEYS.ADD_CANDIDATES.MODAL.TITLE]: 'Add Candidates',
  [KEYS.ADD_CANDIDATES.MODAL.INPUT_PLACEHOLDER]: 'Enter talent LinkedIn URL ',
  [KEYS.ADDING_CANDIDATES]: 'Adding candidates',
  [KEYS.BASIC_PARAMETERS]: 'Basic parameters',
  [KEYS.CUSTOM_MATCH_CONSTRAINTS]: 'Custom match constraints',
  [KEYS.AVERAGE_TENURE_IN_ROLES]: 'Average tenure In Roles',
  [KEYS.TOTAL_YEARS_OF_EXPERIENCE]: 'Total years of Experience',
  [KEYS.AVERAGE_TENURE_IN_COMPANIES]: 'Average tenure in companies',
  [KEYS.TRAJECTORY]: 'Trajectory',
  [KEYS.JOB_CATEGORY]: 'Job category',
  [KEYS.HARD_SKILLS]: 'Hard skills',
  [KEYS.SOFT_SKILLS]: 'Soft skills',
  [KEYS.JOB_CATEGORIES_EXPERIENCE]: 'Job categories experience',
  [KEYS.INDUSTRY]: 'Industry',
  [KEYS.JOB_TITLE]: 'Job Title',
  [KEYS.CREATE_NEW_EDUCATION_INSTITUTE]: 'Create Education Institute',
  [KEYS.EDUCATION_INSTITUTE_LOGO]: 'Education Institute Logo',
  [KEYS.EDUCATION_INSTITUTE_NAME]: 'Education Institute Name',
  [KEYS.PROMOTING_STATUS.PENDING_REVIEW]: 'Pending review',
  [KEYS.PROMOTING_STATUS.PROMOTION_FAILED]: 'Promoting failed',
  [KEYS.PROMOTING_STATUS.PROMOTION_FINISHED]: 'Promoting finished',
  [KEYS.PROMOTING_STATUS.PROMOTION_IN_PROGRESS]: 'Promoting in progress',
  [KEYS.PENDING_PROMOTION_TEXT]: 'Pending Promotion...',
  [KEYS.PROMOTING_STATUS.PENDING_PROMOTION]: 'Pending promotion',
  [KEYS.PROMOTING_STATUS.DELETED]: 'Deleted',
  [KEYS.CANCEL_SEARCH]: 'Cancel Search',
  [KEYS.SEARCH_RUN]: 'Search Run',
  [KEYS.CANCELED]: 'Canceled',
  [KEYS.RUN_DETAILS]: 'Run details',
  [KEYS.RUN_DETAILS_ID]: 'ID: {{id}}',
  [KEYS.CHANGE_ASSOCIATED_COMPANY]: 'Change associated company',
  [KEYS.ASSOCIATED_COMPANY_LABEL]: 'Associated company',
  [KEYS.ADD_COMPANY]: 'Add Company',
  [KEYS.CONTACT_INFO]: 'Contact Info',
  [KEYS.CONTACT_INFO_REQUEST]: 'Contact Info Request',
  [KEYS.UPDATE_CONTACT_INFO_INFORMATION]: 'Add or update talent contact information',
  [KEYS.SEARCHING_DATABASE]: 'Searching database',
  [KEYS.GET_CONTACT_INFO]: 'Get contact info',
  [KEYS.CONTACT_INFO_STATUS_DONE]: 'Contact info added',
  [KEYS.CONTACT_INFO_STATUS_ERROR]: 'Sorry, something went wrong. try again?',
  [KEYS.CONTACT_INFO_STATUS_NO_RESULTS]: 'No results from SignalHire',
  [KEYS.HARDCODED_EXEMPLARS.SELECTED_COUNTER]: '{{ number }} exemplars added',
  [KEYS.EMAIL_DOMAIN]: 'Email Domain',
  [KEYS.ALLOWED_WRONG_EMAIL_DOMAIN]: 'Email Domain should be in format: domain.com',
  [KEYS.ACCEPT]: 'accept',
  [KEYS.REJECT]: 'reject',
  [KEYS.DRAFT]: 'Draft',
  [KEYS.MATCH_REJECT_ERROR_MESSAGE]: 'There was a problem rejecting the match, Please try again',
  [KEYS.MATCHES_REJECT_DIALOG_TITLE]: 'Reject These Matches?',
  [KEYS.MATCHES_REJECT_DIALOG_SUB_TITLE]: 'This action cannot be undone.',
  [KEYS.MATCHES_REJECT_DIALOG_ACTION_BTN]: 'Reject These Matches',
  [KEYS.REJECT_THIS_MATCH_LABEL]: 'Reject this match',
  [KEYS.HARDCODE_EXEMPLAR_LINKEDIN_BROKEN_LINK_ERROR]: 'This link was marked as \'Broken\' and this profile was removed from the system',
  [KEYS.MATCH_RESULT]: 'Match Results',
  [KEYS.ALL_RUNS]: 'All Runs',
  [KEYS.PER_RUN]: 'Per Run',
  [KEYS.START_FOR]: 'Stats For',
  [KEYS.DECLINE_RATE]: 'Decline Rate',
  [KEYS.RELEVANCE_RATE]: 'Relevance Rate',
  [KEYS.RESULTS]: 'Results',
  [KEYS.ENTER_JOB_TITLE]: 'Enter Job Title',
  [KEYS.ENTER_KEYWORDS]: 'Enter keywords',
  [KEYS.ENTER_S3_URL]: 'Enter s3 url',
  [KEYS.SIMILAR_PRIORITIZED_JOB_TITLES]: 'Similar Prioritized Job Titles',
  [KEYS.ADD_SEMANTIC_ITEM]: 'Add semantic item',
  [KEYS.TARGET_LOCATIONS]: 'Target locations',
  [KEYS.ENTER_INDUSTRY_NAME]: 'Enter industry name',
  [KEYS.COMPANY_BLOCK_LIST]: 'Company block list',
  [KEYS.COMPANY_ALLOW_LIST]: 'Company allow list',
  [KEYS.ENTER_COMPANY_LINKEDIN_URL]: 'Enter company LinkedIn URL',
  [KEYS.ENTER_FIELD_OF_STUDY]: 'Enter field of study',
  [KEYS.MINIMUM]: 'Minimum',
  [KEYS.MAXIMUM]: 'Maximum',
  [KEYS.COMPANY_SEMANTIC_SEARCH_TEXT_INPUT_LABEL]: 'Company semantic search text',
  [KEYS.COMPANY_SEMANTIC_SEARCH_SCORE_THRESHOLD_INPUT_LABEL]: 'Company semantic search score threshold',
  [KEYS.TALENT_SEMANTIC_SEARCH_TEXT_INPUT_LABEL]: 'Talent semantic search text',
  [KEYS.TALENT_SEMANTIC_SEARCH_SORT_WEIGHT_INPUT_LABEL]: 'Talent semantic search sort weight',
  [KEYS.MONTHS]: 'Months',
  [KEYS.INCLUDE_VERBOSE_LEVEL]: 'Verbose Level',
  [KEYS.INCLUDE_VERBOSE_LEVEL_DESCRIPTION]: 'Document run filtering summary',
  [KEYS.EXCLUDED_JOB_TITLES]: 'Titles To Exclude',
  [KEYS.IGNORE_TITLES_FILTER]: 'Ignore Titles filter',
  [KEYS.IGNORE_TITLES_FILTER_DESCRIPTION]: 'Ignore provided titles',
  [KEYS.MATCH_ENGINE_STATISTICS_ERROR]: 'Something went wrong, please try again',
  [KEYS.POTENTIAL_CANDIDATES_S3_URL]: 'Potential candidates s3 url',
  [KEYS.OUTREACH_TRIAL_OVERRIDE_LABEL]: 'Enable Outreach for Trial',
  [KEYS.OUTREACH_TRIAL_OVERRIDE_HELPER_DISABLED]: 'Available on Trial plans only',
  [KEYS.OUTREACH_TRIAL_OVERRIDE_HELPER_LOCKED]: 'Outreach is enabled — cannot be disabled',
  [KEYS.OUTREACH_TRIAL_OVERRIDE_CONFIRM_TITLE]: 'Enable Outreach for this trial?',
  [KEYS.OUTREACH_TRIAL_OVERRIDE_CONFIRM_BODY]: 'This action cannot be undone. Trial users will be able to activate outreach campaigns.',
  [KEYS.OUTREACH_TRIAL_OVERRIDE_CONFIRM_OK]: 'Enable',
  [KEYS.OUTREACH_TRIAL_OVERRIDE_CONFIRM_CANCEL]: 'Cancel',
  [KEYS.LAYOUT_REFERRALS_TITLE]: 'Referrals',
  [KEYS.REFERRALS.FILTER_STATUS]: 'Status',
  [KEYS.REFERRALS.FILTER_ELIGIBILITY]: 'Eligibility',
  [KEYS.REFERRALS.FILTER_ALL]: 'All',
  [KEYS.REFERRALS.FILTER_UNLINKED]: 'Unlinked',
  [KEYS.REFERRALS.FILTER_PAYOUT_FAILED]: 'Payout failures',
  [KEYS.REFERRALS.FILTER_NO_HUBSPOT_STATUS]: 'No HubSpot status after 7 days',
  [KEYS.REFERRALS.TAX_REPORT_BUTTON]: 'Tax report',
  [KEYS.REFERRALS.TABLE_HEADER_REFERRER]: 'Referrer',
  [KEYS.REFERRALS.TABLE_HEADER_FRIEND_COMPANY]: 'Friend company',
  [KEYS.REFERRALS.TABLE_HEADER_CREATED]: 'Created',
  [KEYS.REFERRALS.TABLE_HEADER_PATH]: 'Path',
  [KEYS.REFERRALS.TABLE_HEADER_STATUS]: 'Status',
  [KEYS.REFERRALS.TABLE_HEADER_ELIGIBILITY]: 'Eligibility',
  [KEYS.REFERRALS.TABLE_HEADER_LINKED_ACCOUNT]: 'Linked account',
  [KEYS.REFERRALS.TABLE_HEADER_REWARDS]: 'Rewards',
  [KEYS.REFERRALS.TABLE_HEADER_POSITION]: 'Position',
  [KEYS.REFERRALS.EMPTY]: 'No referrals match these filters.',
  [KEYS.REFERRALS.LOAD_ERROR]: 'Referrals could not be loaded: {{message}}',
  [KEYS.REFERRALS.ACTION_ERROR]: 'The action failed: {{message}}',
  [KEYS.REFERRALS.EMAIL_INTRO]: 'Email intro',
  [KEYS.REFERRALS.NOT_LINKED]: 'Not linked',
  [KEYS.REFERRALS.PAYING_OUTSIDE_STRIPE]: 'Pays outside Stripe',
  [KEYS.REFERRALS.NO_PATH]: 'Not chosen',
  [KEYS.REFERRALS.OVERRIDDEN]: 'Overridden',
  [KEYS.REFERRALS.MILESTONE]: 'M{{milestone}}',
  [KEYS.REFERRALS.FALLBACK]: 'Fallback: {{reason}}',
  [KEYS.REFERRALS.POSITION_UNTIL]: 'Until {{date}}',
  [KEYS.REFERRALS.POSITION_ONGOING]: 'Ongoing while they pay',
  [KEYS.REFERRALS.POSITION_ENDED]: 'Ended {{date}} ({{reason}})',
  [KEYS.REFERRALS.ACTION_OVERRIDE_ELIGIBILITY]: 'Override eligibility',
  [KEYS.REFERRALS.ACTION_RECHECK_ELIGIBILITY]: 'Re-check eligibility',
  [KEYS.REFERRALS.ACTION_LINK_ACCOUNT]: 'Link account',
  [KEYS.REFERRALS.ACTION_CHANGE_LINKED_ACCOUNT]: 'Change linked account',
  [KEYS.REFERRALS.ACTION_UNLINK_ACCOUNT]: 'Unlink account',
  [KEYS.REFERRALS.ACTION_SET_PAYING_OUTSIDE_STRIPE]: 'Mark as paying outside Stripe',
  [KEYS.REFERRALS.ACTION_CLEAR_PAYING_OUTSIDE_STRIPE]: 'Unmark paying outside Stripe',
  [KEYS.REFERRALS.ACTION_QUALIFY]: 'Mark demo qualified',
  [KEYS.REFERRALS.ACTION_RESEND_REWARD]: 'Resend / redirect M{{milestone}} gift card',
  [KEYS.REFERRALS.ACTION_REISSUE_REWARD]: 'Re-issue M{{milestone}} gift card',
  [KEYS.REFERRALS.ACTION_END_POSITION]: 'End referral position',
  [KEYS.REFERRALS.OVERRIDE_DIALOG_TITLE]: 'Override eligibility?',
  [KEYS.REFERRALS.OVERRIDE_DIALOG_SUB_TITLE]:
    'This referral becomes eligible. If the demo is already qualified or paid, rewards are issued automatically.',
  [KEYS.REFERRALS.OVERRIDE_DIALOG_REASON]: 'Reason',
  [KEYS.REFERRALS.OVERRIDE_DIALOG_BTN]: 'Override',
  [KEYS.REFERRALS.LINK_DIALOG_TITLE]: 'Link the referred account',
  [KEYS.REFERRALS.LINK_DIALOG_SUB_TITLE]:
    'Pick the account {{company}} signed up as. If it has already paid, the payment milestone is processed right away.',
  [KEYS.REFERRALS.LINK_DIALOG_SEARCH]: 'Search accounts by name',
  [KEYS.REFERRALS.LINK_DIALOG_BTN]: 'Link',
  [KEYS.REFERRALS.UNLINK_DIALOG_TITLE]: 'Unlink the referred account?',
  [KEYS.REFERRALS.UNLINK_DIALOG_SUB_TITLE]: 'Payments by that account will stop counting toward this referral.',
  [KEYS.REFERRALS.UNLINK_DIALOG_BTN]: 'Unlink',
  [KEYS.REFERRALS.QUALIFY_DIALOG_TITLE]: 'Mark the demo qualified?',
  [KEYS.REFERRALS.QUALIFY_DIALOG_SUB_TITLE]:
    'Use this only when HubSpot is unavailable. The referrer is rewarded automatically (gift card or free position).',
  [KEYS.REFERRALS.QUALIFY_DIALOG_BTN]: 'Mark qualified',
  [KEYS.REFERRALS.RESEND_DIALOG_TITLE]: 'Resend the M{{milestone}} gift card',
  [KEYS.REFERRALS.RESEND_DIALOG_SUB_TITLE]:
    'Resending uses the same order. Redirecting cancels it and orders a replacement {{amount}} gift card to the new email.',
  [KEYS.REFERRALS.RESEND_DIALOG_SAME_EMAIL]: 'Resend to {{email}}',
  [KEYS.REFERRALS.RESEND_DIALOG_NEW_EMAIL]: 'Redirect to a new email',
  [KEYS.REFERRALS.RESEND_DIALOG_EMAIL_LABEL]: 'New email',
  [KEYS.REFERRALS.RESEND_DIALOG_EMAIL_INVALID]: 'Enter a valid email',
  [KEYS.REFERRALS.RESEND_DIALOG_BTN]: 'Resend',
  [KEYS.REFERRALS.REDIRECT_DIALOG_BTN]: 'Cancel and re-order',
  [KEYS.REFERRALS.REISSUE_DIALOG_TITLE]: 'Re-issue the canceled M{{milestone}} gift card',
  [KEYS.REFERRALS.REISSUE_DIALOG_SUB_TITLE]:
    'The original gift card was canceled. This sends a new {{amount}} gift card for the same amount, to the original email or a new one.',
  [KEYS.REFERRALS.REISSUE_DIALOG_SAME_EMAIL]: 'Send to {{email}}',
  [KEYS.REFERRALS.REISSUE_DIALOG_NEW_EMAIL]: 'Send to a new email',
  [KEYS.REFERRALS.REISSUE_DIALOG_BTN]: 'Re-issue',
  [KEYS.REFERRALS.ACTION_FORCE_SEND_REWARD]: 'Send held M{{milestone}} gift card now',
  [KEYS.REFERRALS.FORCE_SEND_DIALOG_TITLE]: 'Send the held M{{milestone}} {{amount}} gift card now?',
  [KEYS.REFERRALS.FORCE_SEND_DIALOG_SUB_TITLE]:
    'This bypasses the $5,000-per-24-hours spending limit for this gift card. It is still held if gift cards are switched off or Tremendous is not configured.',
  [KEYS.REFERRALS.FORCE_SEND_DIALOG_BTN]: 'Send now',
  [KEYS.REFERRAL_FORCE_SEND_OUTCOMES.SENT]: 'Gift card sent.',
  [KEYS.REFERRAL_FORCE_SEND_OUTCOMES.HELD_DISABLED]: 'Gift card not sent: gift cards are switched off.',
  [KEYS.REFERRAL_FORCE_SEND_OUTCOMES.HELD_NOT_CONFIGURED]: 'Gift card not sent: Tremendous is not configured.',
  [KEYS.REFERRAL_FORCE_SEND_OUTCOMES.HELD_BREAKER]: 'Gift card not sent: still held by the spending limit.',
  [KEYS.REFERRAL_FORCE_SEND_OUTCOMES.FAILED]: 'Gift card not sent: the order to Tremendous failed. It will be retried automatically.',
  [KEYS.REFERRAL_FORCE_SEND_OUTCOMES.NOT_ISSUABLE]:
    'Nothing sent: this gift card is no longer waiting to be sent (already sent, or changed since the page loaded).',
  [KEYS.REFERRALS.FORCE_SEND_OUTCOME_WITH_REASON]: '{{outcome}} Reason: {{reason}}',
  [KEYS.REFERRALS.END_POSITION_DIALOG_TITLE]: 'End this referral position now?',
  [KEYS.REFERRALS.END_POSITION_DIALOG_SUB_TITLE]:
    'The account loses this free position immediately. If it is over its cap, its newest open position is locked. Ended positions cannot be restarted.',
  [KEYS.REFERRALS.END_POSITION_DIALOG_BTN]: 'End position',
  [KEYS.REFERRALS.TAX_REPORT_DIALOG_TITLE]: 'Download tax report',
  [KEYS.REFERRALS.TAX_REPORT_DIALOG_SUB_TITLE]:
    'Gift card totals per recipient for the year. Recipients at $2,000 or more are flagged for a 1099.',
  [KEYS.REFERRALS.TAX_REPORT_DIALOG_YEAR]: 'Year',
  [KEYS.REFERRALS.TAX_REPORT_DIALOG_BTN]: 'Download CSV',
  [KEYS.REFERRALS.TAX_REPORT_ERROR]: 'The tax report could not be downloaded.',
  [KEYS.REFERRALS.ACCOUNT_PANEL_TITLE]: 'Referral Positions',
  [KEYS.REFERRALS.ACCOUNT_PANEL_COUNT]: '{{count}} free referral position(s): cap is {{total}} ({{paid}} paid + {{count}} referral)',
  [KEYS.REFERRALS.ACCOUNT_PANEL_POSITION]: 'From the {{company}} referral: {{period}}',
  [KEYS.REFERRALS.ACCOUNT_PANEL_REFERRED_BY]: 'Referred by {{name}}',
  [KEYS.REFERRALS.ACCOUNT_PANEL_LOAD_ERROR]: 'Referral details could not be loaded.',
  [KEYS.REFERRALS.UNKNOWN_COMPANY]: 'Unknown company',
  [KEYS.REFERRALS.UNKNOWN_REFERRER]: 'Unknown referrer',
  [KEYS.REFERRALS.PROGRAM_DISABLED]: 'Referral program is turned off in this environment.',
  [KEYS.REFERRALS.HUBSPOT_UNAVAILABLE]: 'HubSpot is unavailable right now, try again shortly.',
  [KEYS.REFERRAL_STATUSES.CREATED]: 'Demo booked',
  [KEYS.REFERRAL_STATUSES.NOT_QUALIFIED]: 'Not qualified',
  [KEYS.REFERRAL_STATUSES.QUALIFIED]: 'Qualified',
  [KEYS.REFERRAL_STATUSES.PAID]: 'Paid',
  [KEYS.REFERRAL_STATUSES.ENDED]: 'Ended',
  [KEYS.REFERRAL_ELIGIBILITIES.ELIGIBLE]: 'Eligible',
  [KEYS.REFERRAL_ELIGIBILITIES.INELIGIBLE]: 'Not eligible',
  [KEYS.REFERRAL_INELIGIBILITY_REASONS.CURRENT_CUSTOMER]: 'Current customer',
  [KEYS.REFERRAL_INELIGIBILITY_REASONS.RECENT_SALES_CONTACT]: 'Demo or deal in the last 6 months',
  [KEYS.REFERRAL_INELIGIBILITY_REASONS.DUPLICATE]: 'Already referred',
  [KEYS.REFERRAL_INELIGIBILITY_REASONS.SELF_REFERRAL]: 'Self-referral',
  [KEYS.REFERRAL_INELIGIBILITY_REASONS.UNKNOWN_REFERRER]: 'Unknown referrer',
  [KEYS.REFERRAL_PATHS.GIFT_CARD]: 'Gift card',
  [KEYS.REFERRAL_PATHS.POSITION]: 'Free position',
  [KEYS.REFERRAL_REWARD_STATUSES.AWAITING_PATH]: 'Awaiting path',
  [KEYS.REFERRAL_REWARD_STATUSES.PROCESSING]: 'Processing',
  [KEYS.REFERRAL_REWARD_STATUSES.SENT]: 'Sent',
  [KEYS.REFERRAL_REWARD_STATUSES.DELIVERY_FAILED]: 'Delivery failed',
  [KEYS.REFERRAL_REWARD_STATUSES.POSITION_GRANTED]: 'Position granted',
  [KEYS.REFERRAL_REWARD_STATUSES.CANCELED]: 'Canceled',
  [KEYS.REFERRAL_FALLBACK_REASONS.NO_CAP]: 'plan has no position cap',
  [KEYS.REFERRAL_FALLBACK_REASONS.REFERRER_GONE]: 'referrer no longer has a login',
  [KEYS.REFERRAL_POSITION_END_REASONS.TERM_ELAPSED]: 'term ended',
  [KEYS.REFERRAL_POSITION_END_REASONS.REFERRED_STOPPED_PAYING]: 'friend stopped paying',
  [KEYS.REFERRAL_POSITION_END_REASONS.MANUAL]: 'ended manually',
};

export default STRINGS;
